import React from 'react'
import { Translate } from 'react-localize-redux'
import groupPlayersByPosition from 'utils/groupPlayersByPosition'
import PropTypes from 'prop-types'
import { Box, Button, Typography } from '@material-ui/core'
import PlayersListCard from '../Team/PlayersListCard'
import PlayersTable from '../Team/PlayersTable'

const RostersListContainer = ({ players, setTabValue }) => {
  const { goalkeepers, defenders, midfielders, strikers } =
    groupPlayersByPosition(
      players.map((p) => {
        return {
          uuid: p.uuid,
          player_uuid: p.relationships.player?.uuid,
          first_name: p.relationships.player?.first_name,
          last_name: p.relationships.player?.last_name,
          number: p.relationships.player?.number,
          avatar: p.relationships.player?.relationships?.avatar?.full_url,
          availability: p.availability,
          participant: p.participant,
          tag: p.tag,
          reason: p.reason,
          in_roster: p.in_roster,
          position: p.relationships.player?.position,
        }
      })
    )

  return (
    <>
      {players.length === 0 && (
        <Box p={12} textAlign="center" style={{ height: '80vh' }}>
          <Typography variant="h5" gutterBottom>
            <Translate id="matches.add-roster-text" />
          </Typography>
          <Box>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => setTabValue('team')}
            >
              <Translate id="matches.create-roster" />
            </Button>
          </Box>
        </Box>
      )}
      {players.length > 0 && (
        <>
          {goalkeepers && (
            <PlayersListCard title={<Translate id="matches.goalkeeper" />}>
              <PlayersTable matchPlayers={goalkeepers} isRoster />
            </PlayersListCard>
          )}

          {defenders && (
            <PlayersListCard title={<Translate id="matches.defender" />}>
              <PlayersTable matchPlayers={defenders} isRoster />
            </PlayersListCard>
          )}

          {midfielders && (
            <PlayersListCard title={<Translate id="matches.midfield" />}>
              <PlayersTable matchPlayers={midfielders} isRoster />
            </PlayersListCard>
          )}
          {strikers && (
            <PlayersListCard title={<Translate id="matches.striker" />}>
              <PlayersTable matchPlayers={strikers} isRoster />
            </PlayersListCard>
          )}
        </>
      )}
    </>
  )
}

RostersListContainer.defaultProps = {
  players: [],
}

RostersListContainer.propTypes = {
  players: PropTypes.arrayOf(PropTypes.shape({})),
  setTabValue: PropTypes.func.isRequired,
}

export default RostersListContainer
